import React from 'react';
import { resolveStyle, StyleSheet, Text } from './base_components';

const styles = StyleSheet.create({
  label: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  text: {
    marginLeft: '0.5rem',
  },
});

type Props = {
  style?: any;
  textStyle?: any;
  className?: any;
  text: string;
  value: boolean;
  onChange: (boolean) => void;
};
export default class Checkbox extends React.PureComponent<Props> {
  _onChange = (e) => {
    const { onChange } = this.props;
    onChange(e.target.checked || false);
  };
  render() {
    const { style, textStyle, text, value, className: extraClass } = this.props;

    const { className, inlineStyle } = resolveStyle(
      [styles.label, style],
      extraClass
    );

    return (
      <label className={'form-check ' + className} style={inlineStyle}>
        <input
          type='checkbox'
          className='form-check-input'
          checked={value ? 1 : 0}
          onChange={this._onChange}
        />
        <Text style={[styles.text, textStyle]}>{text}</Text>
      </label>
    );
  }
}
